import { useHistory, useRouteMatch } from "react-router-dom";
import Button from "../organism/Button";
import CustomTabProps from "../../services/models/customTabProps.model";

function CustomTab({
  to,
  activeOnlyWhenExact,
  ...buttonProps
}: CustomTabProps): JSX.Element {
  const history = useHistory();
  const match = useRouteMatch({
    path: to,
    exact: activeOnlyWhenExact,
  });

  function redirect() {
    history.push(to);
  }
  return (
    <Button
      {...buttonProps}
      onClick={redirect}
      buttonTheme={match ? "primary" : "transparent"}
      className={`${match ? "" : "px-4"} text-sm capitalize mx-auto`}
    />
  );
}

export default CustomTab;
